import { Button, Collapse } from "components/Core"
import { Select } from "flowbite-react"
import { useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { LocationsContext } from "store/context/LocationsContext";

interface IFieldSelectSimple {
  field: any
  apply_filter: any
}

const FieldSelectSimple = ({ field: _field, apply_filter }: IFieldSelectSimple) => {

  const { setSelectedPolygonType } = useContext(LocationsContext);
  const { pathname } = useLocation();
  const { id, label, options } = _field
  const { selectedPolygonType } = useContext(LocationsContext);
  const [value, set_value] = useState<string>("")

  useEffect(() => {
    if (id === 'polygonType') {
      set_value(selectedPolygonType || "");
    }
  }, [id, selectedPolygonType]);

  const handle_change_value = (e: any) => {
    e.preventDefault()
    const selectedValue = e?.target?.value;
    set_value(selectedValue)
    if (id === 'polygonType' && setSelectedPolygonType) {
      setSelectedPolygonType(selectedValue);
    }
  }

  const apply_filter_value = () => {
    apply_filter({ ..._field, value })
  }

  return (
    <Collapse name={id} header={<h1>{label}</h1>}>
      <div className="w-full flex flex-row items-center justify-center gap-2">
        <div className="relative w-full h-14">
          <Select onChange={handle_change_value} value={value} className="w-full h-full">
            {options?.length ? (
              <>
                <option value="" disabled>
                  Seleccione...
                </option>
                {options?.map((item: any, i: number) => (
                  <option key={i} value={item?.value}>
                    {item?.label}
                  </option>
                ))}
              </>
            ) : (
              <option disabled>Sin opciones</option>
            )}
          </Select>
        </div>
        {pathname !== "/coverages/map" && (
          <Button label="Aplicar" disabled={Boolean(!value)} className="w-28 !p-0" onClick={apply_filter_value} />
        )}
      </div>
    </Collapse>
  )
}

export default FieldSelectSimple
